import { useConsoleContext } from './console-context.tsx';

export interface Crumb {
  label: string;
  href?: string;
}

/**
 * The root of a breadcrumb trail, resolved from what the page is actually about.
 *
 * Six pages hardcoded "Parallax Motion" as their root — Licences, Usage,
 * Analytics, Settings, and every Developers route. All of them are VENDOR
 * resources: N-Expert.ai's licences, N-Expert.ai's API keys. Naming Parallax
 * Motion above them says the opposite of the truth, and it says it on exactly
 * the pages where getting the tenant wrong matters most.
 *
 * Parallax Motion is the platform vendor. It appears in the wordmark — "Verydia
 * Control, by Parallax Motion" — and it is never the selected organization.
 *
 * Two roots, chosen by what the resource belongs to rather than by which file
 * the route happens to live in:
 *
 *   vendor    → the validated organization name
 *   platform  → "Platform", for Parallax Motion's own administration
 */
export function useVendorBreadcrumbs(...trail: readonly Crumb[]): Crumb[] {
  const context = useConsoleContext();

  // Falls back to a neutral word rather than to a company name. While the
  // organization is still resolving, naming ANY organization would be a guess,
  // and the wrong guess here is a tenant mix-up.
  return [{ label: context.organization?.name ?? 'Organization', href: '/' }, ...trail];
}

export function platformBreadcrumbs(...trail: readonly Crumb[]): Crumb[] {
  return [{ label: 'Platform', href: '/' }, ...trail];
}
